__turbopack_context__.v({
  "ageVerifyBody": "ageVerify-module-scss-module__wEc58a__ageVerifyBody",
  "btn": "ageVerify-module-scss-module__wEc58a__btn",
  "closeImg": "ageVerify-module-scss-module__wEc58a__closeImg",
  "customIcon": "ageVerify-module-scss-module__wEc58a__customIcon",
  "guestText": "ageVerify-module-scss-module__wEc58a__guestText",
  "text": "ageVerify-module-scss-module__wEc58a__text",
});
